import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentOptions from '../components/PaymentOptions';
import CheckoutForm from '../components/CheckoutForm';
import { redirectIfNotLogin } from '../functions/userFuncs';
import axios from 'axios';
import { message } from 'antd';
import Header from '../components/Header';
import { getUser } from '../functions/userFuncs';

const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  throw new Error("REACT_APP_STRIPE_PUBLISHABLE_KEY is not set in the environment variables");
}

const stripePromise = loadStripe(stripePublishableKey);

const PaymentPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedReport, setSelectedReport] = useState<any>();
  const [selectedPlan, setSelectedPlan] = useState<any>();
  const [clientSecretCode, setClientSecretCode] = useState('');
  const [amount, setAmount] = useState<number>(); // Initial value
  const [userEmail, setUserEmail] = useState<string | null>(null); // Store user email
  const [isReadyToRenderCheckout, setIsReadyToRenderCheckout] = useState(false); // New state


  const handleSelectPlan = async (plan:any) => {
    setSelectedPlan(plan);
    try {
      await createPaymentIntent(plan.price * 100); // Assuming plan.price is in the correct format
      setIsReadyToRenderCheckout(true); // Set to true once the payment intent is created
    } catch (error) {
      console.error('Error selecting plan and creating payment intent:', error);
      setIsReadyToRenderCheckout(false); // Ensure it's false if there's an error
    }
  };
  
  const createPaymentIntent = async (amount:number) => {
    if (userEmail) {
      try {
        const response = await fetch(`${process.env.REACT_APP_INSTANCE}/create-payment-intent`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            amount: amount,
            currency: 'gbp',
            email: userEmail,
          }),
        });
        const data = await response.json();
        if (data.clientSecret) {
          setClientSecretCode(data.clientSecret);
        } else {
          throw new Error('Client secret not found in response');
        }
      } catch (error) {
        console.error('Error creating payment intent:', error);
        throw error;
      }
    } else {
      console.error('User email is not available.');
      throw new Error('User email is not available');
    }
  };
  

  useEffect(() => {
    const splittedPath = location.pathname.split('/');
    const reportID = splittedPath[splittedPath.length - 1];
    axios
      .get(`${process.env.REACT_APP_INSTANCE}/api/report/byID/${reportID}`)
      .then((res: any) => {
        if (!res.data.report.termsAndConditionsAccepted) {
          message.error('Please agree to our terms and conditions!');
          return navigate('/status');
        }
        setSelectedReport(res.data.report);
      });
  }, []);

  const handlePaymentSuccess = async () => {
    if (selectedReport) {
      // Mark as paid
      await axios.patch(
        `${process.env.REACT_APP_INSTANCE}/api/item/selectPlan`,
        {
          _paymentPlan: selectedPlan._id,
          _report: selectedReport._id,
        }
      );
      message.success(
        `Thank you for your payment - Seeker is now searching for your stolen item(s)`
        // `Successfully paid for ${selectedReport.brand} ${selectedReport.model}`
      );
    }

    navigate('/status'); // Navigate to status page on payment success
  };

  useEffect(() => {
    redirectIfNotLogin(navigate);
    getUser().then(user => {
      setUserEmail(user?.attributes?.email); // Correctly access the email
    });
  }, [navigate]);
  



  return (
    <div>
      <Header />
      <div className="payment-page" style={{ marginTop: '100px' }}>
        {!selectedPlan ? (
          <PaymentOptions onSelectPlan={handleSelectPlan} selectedReport={selectedReport} />
        ) : (
          <div>
            {isReadyToRenderCheckout ? (
              <Elements stripe={stripePromise} options={{ clientSecret: clientSecretCode }}>
                <CheckoutForm
                  onPaymentSuccess={handlePaymentSuccess}
                  selectedPlan={selectedPlan}
                  selectedReport={selectedReport}
                />
              </Elements>
            ) : (
              <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                textAlign: 'center',
              }}
            >
              <p>Loading payment details...</p>
            </div>            )}
          </div>
        )}
      </div>
    </div>
  );
  
};

export default PaymentPage;
